import React from 'react'
import MappingTabs from './MappingTabs'

const HWTab = () => <MappingTabs />

export default HWTab



// WEBPACK FOOTER //
// ./src/components/ChannelTabs/HWTab/HWTab.js